import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import sift from "sift";
import capitalize from "capitalize";
import config from "../../config";
import { lowercaseAndParseSpaces } from "../../utils";
import { generateBuilderSlug } from "../utils";
export var initFiltersOptions = function initFiltersOptions(a) {
  var b = {// propertyType: ["house", "townhome", "apartment"],
    // frontage: 'low-high',
    // area: 'low-high', // equals to landSize
    // price: 'low-high',
    // bed: 'options', // equals to bedrooms
    // bath: 'options', // equals to bathrooms
    // car: 'options', // equals to parking
    // stories: 'options',
    // builders: 'options',
    // lots: 'options',
    // otherOptions: ['waterfront', 'golf-course', 'titled', 'school', 'corner', 'promoted'],
  },
      c = function c(a, _c) {
    var d = null == _c.label ? capitalize(a) : _c.label,
        e = {
      type: "range",
      label: d,
      name: a
    };
    if (_c.options) // @NOTE from should always start from 1
      e.from = _c.from || Math.min.apply(Math, _toConsumableArray(_c.options)) || 1, e.to = _c.to || Math.max.apply(Math, _toConsumableArray(_c.options));else {
      var f = b[a] || {},
          g = f.to,
          h = f.from,
          i = _c.original || {},
          j = i.low,
          k = i.high,
          l = _c.step;
      e.from = h ? Math.max(h, j) : j, e.to = g ? Math.min(g, k) : k, e.step = l;
    } // some packages values have different name on the api
    // so each filter has a { apiName } field if needed

    _c.apiName && (e.apiName = _c.apiName), b[a] = e;
  },
      d = function d(a, c) {
    var d = null == c.label ? capitalize(a) : c.label,
        e = {
      type: "select",
      label: d,
      options: c.options,
      name: a
    };
    c.apiName && (e.apiName = c.apiName), b[a] = e;
  },
      e = function e(a, c) {
    var d = null == c.label ? capitalize(a) : c.label,
        e = {
      type: "check-list",
      label: d,
      options: c.options,
      name: a
    };
    c.apiName && (e.apiName = c.apiName), b[a] = e;
  },
      f = a.current,
      g = a.packageSearch,
      h = f || {},
      i = h.packages,
      j = void 0 === i ? [] : i,
      k = h.townhomes,
      l = void 0 === k ? [] : k,
      m = h.apartments,
      n = void 0 === m ? [] : m;

  if (f) {
    var o = [],
        p = j.find(function (a) {
      return a.lot_id;
    }); // @TODO REMOVE WHEN API ADDS PROPERTY TYPE TO THE PACKAGES

    p && o.push({
      name: "packages",
      label: "House & Land",
      value: "house",
      icon: "houseandland"
    });
    var I = l.length && l.find(sift({
      available_townhomes: !0
    }));
    I && o.push({
      name: "townhomes",
      label: "Townhomes",
      value: "townhome",
      icon: "townhome"
    });
    var J = n.length && n.available_aparments;
    J && o.push({
      name: "apartments",
      label: "Apartments",
      value: "apartment",
      icon: "apartment"
    });
    e("propertyType", {
      label: "Property type",
      options: o
    });
  }

  if (config.api.get("project")) {
    // if a project is selected on the config then show the neighbourhoods
    var q = a.neighbourhoods.list(),
        r = q.data,
        s = r.map(function (a) {
      var b = a.name,
          c = a.slug,
          d = a.packages,
          e = a.landforsale;
      return {
        name: b,
        label: b,
        value: c,
        landforsale: e.length,
        packages: d.length
      };
    }),
        t = {
      label: config.labels.get("filters.neighbourhood"),
      options: s.filter(function (a) {
        return null !== a;
      }),
      apiName: "neighbourhood_slug"
    };
    e("neighbourhood", t);
  } else if (!config.api.get("neighbourhood")) {
    // if a project is not selected on the config then show the projects (estates)
    var u = a.projects.list(),
        v = u.data,
        w = v.map(function (a) {
      var b = a.estate_name,
          c = a.slug;
      return {
        name: b,
        label: config.estates.get("".concat(c, ".label")),
        value: c,
        image: config.estates.get("".concat(c, ".logo")),
        color: config.estates.get("".concat(c, ".color"))
      };
    }),
        x = {
      label: config.labels.get("filters.estate"),
      options: w,
      apiName: "project_slug"
    };
    e("estate", x);
  }

  if (g) {
    // get search criteria options
    var y = g.frontage,
        z = g.area,
        A = g.price,
        B = g.bed,
        C = g.bath,
        D = g.car,
        E = g.stories,
        F = g.builders; // set <select> elements

    if (F && (F.options = F.options.map(function (a) {
      return a.slug = generateBuilderSlug(a.slug), a;
    }), d("builder", _objectSpread({}, F, {
      apiName: "builders_slug"
    }))), d("release", {
      options: [{
        name: "Parkview",
        slug: "parkview"
      }, {
        name: "Wellington",
        slug: "wellington"
      }, {
        name: "Apium",
        slug: "apium"
      }],
      apiName: "release_slug"
    }), B && c("bedrooms", _objectSpread({}, B, {
      from: parseInt(config.filters.get("bedrooms.from") || B.from),
      to: parseInt(config.filters.get("bedrooms.to") || 5)
    })), C && c("bathrooms", _objectSpread({}, C, {
      from: parseInt(config.filters.get("bathrooms.from") || C.from),
      to: parseInt(config.filters.get("bathrooms.to") || 3)
    })), D && c("parking", _objectSpread({}, D, {
      apiName: "garage",
      from: parseInt(config.filters.get("parking.from") || D.from),
      to: parseInt(config.filters.get("parking.to") || 3)
    })), E && c("stories", _objectSpread({}, E, {
      label: "storeys",
      from: parseInt(config.filters.get("stories.from") || E.from),
      to: parseInt(config.filters.get("stories.to") || 3)
    })), A && c("price", _objectSpread({}, A, {
      step: 25e3
    })), z && c("landSize", _objectSpread({}, z, {
      label: "Land size",
      apiName: "lot_area"
    })), y && c("frontage", _objectSpread({}, y, {
      apiName: "lot_frontage"
    })), y) {
      var G = config.attributes,
          H = {
        label: "Other options",
        options: Object.keys(config.attributes).map(function (a) {
          var b = G[a];
          return {
            name: b,
            label: b,
            value: parseInt(a),
            icon: lowercaseAndParseSpaces(b)
          };
        })
      };
      e("otherOptions", _objectSpread({}, H, {
        apiName: "attributes"
      }));
    }

    var K = {
      label: "Status",
      options: ["promoted", "titled"].map(function (a) {
        return {
          name: a,
          label: a,
          value: a // icon: lowercaseAndParseSpaces(value)

        };
      })
    };
    e("statusOptions", K);
  }

  return b;
};
export default initFiltersOptions;